import { RequestMiddleware } from "@/shared/utils/http-client";

export const authMiddleware = (getAccessToken: () => string | null): RequestMiddleware => {
    return async (request, next) => {
        const token = getAccessToken();
        if (!token) return next(request);

        const headers = new Headers(request.headers);
        headers.set('Authorization', `Bearer ${token}`);
        return next(new Request(request, { headers }));
    }
}